import { Provider } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../../core/use-case";
import { PlanningWizardDTO } from "../../models/planning-wizard.model";
import { AgreementRepository } from "../../repositories/agreement.repository";

interface CreateWorkloadFromOpportunityUseCaseParam {
  agreementId: number;
  wizardValue: PlanningWizardDTO;
}

export class CreateWorkloadFromOpportunityUseCase
  implements UseCase<CreateWorkloadFromOpportunityUseCaseParam, boolean>
{
  constructor(private repo: AgreementRepository) {}
  execute(
    param: CreateWorkloadFromOpportunityUseCaseParam,
  ): Observable<boolean> {
    return this.repo.createWorkloadFromOpportunity(
      param.agreementId,
      param.wizardValue,
    );
  }
}

const createWorkloadFromOpportunityUseCaseFactory = (
  repo: AgreementRepository,
) => new CreateWorkloadFromOpportunityUseCase(repo);

export const createWorkloadFromOpportunityUseCaseProvider: Provider = {
  provide: CreateWorkloadFromOpportunityUseCase,
  useFactory: createWorkloadFromOpportunityUseCaseFactory,
  deps: [AgreementRepository],
};
